module.exports = __webpack_public_path__ + "static/img/yaluanwan2.7fa8674.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yaluanwan2.png
// module id = fnvX
// module chunks = 52